import {createSlice, createAsyncThunk} from "@reduxjs/toolkit";
import {get} from "../../network/axiosServices";


const initialState = {
    loading: false,
    posts: [],
    error: '',
    mediaLoading:false,
    mediaPosts:[],
    mediaError:'',
    detail: [],
    detailLoading: false,
    detailError: ''
}

export const fetchMedia = createAsyncThunk("fetchMedia", (params) => {
    return get(params);
});

export const fetchMediaList = createAsyncThunk("fetchMediaList", (params) => {
    return get(params);
});


export const fetchMediaDetail = createAsyncThunk("fetchMediaDetail", (params) => {
    return get(params);
});



const postSlice = createSlice({
    name: 'media',
    initialState,
    extraReducers: builder => {
        builder.addCase(fetchMedia.pending, (state) => {
            state.loading = true
            state.posts = []
            state.error = ''
        })
        builder.addCase(fetchMedia.fulfilled, (state, action) => {
            state.loading = false
            state.posts = action.payload
            state.error = ''
        })
        builder.addCase(fetchMedia.rejected, (state, action) => {
            state.loading = false
            state.posts = []
            state.error = action.error
        })
        builder.addCase(fetchMediaList.pending, (state) => {
            state.mediaLoading = true
            state.mediaPosts = []
            state.mediaError = ''
        })
        builder.addCase(fetchMediaList.fulfilled, (state, action) => {
            state.mediaLoading = false
            state.mediaPosts = action.payload
            state.mediaError = ''
        })
        builder.addCase(fetchMediaList.rejected, (state, action) => {
            state.mediaLoading = false
            state.mediaPosts = []
            state.mediaError = action.error
        })
        builder.addCase(fetchMediaDetail.pending, (state, action) => {
            state.detailLoading = true
            state.detail = []
            state.detailError = ''
        })
        builder.addCase(fetchMediaDetail.fulfilled, (state, action) => {
            state.detailLoading = false
            state.detail = action.payload
            state.detailError = ''
        })
        builder.addCase(fetchMediaDetail.rejected, (state, action) => {
            state.detailLoading = false
            state.detail = []
            state.detailError = action.error
        })
    }
})


export default postSlice.reducer
